import axios from 'axios';
import * as yup from 'yup';
// import {availableLabelSchema} from "~/schemas/availableLabelSchema";
import { customLabelSchema } from "~/schemas/customLabelSchema";
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup.array().defined().of(customLabelSchema).ensure(),
});
export async function getLabelsRequest() {
    const response = await axios.get('/api/dashboard/labels');
    console.log(response);
    const { data } = await responseSchema.validate(response.data);
    return {
        labels: data
    };
}
